<template>
  <div id="programasinversion-toolbar-programasinversion">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Programas de Inversión
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
